export default __webpack_public_path__ + "static/media/020212202131102.52af09f3.png";